import { IBasketAction, IBasketActionTypes } from '@epicuro-next/data/baskets';

export function getFilteredBasketActions(
  actions: IBasketAction[],
  isAllowedToResendOrderConfirmation: boolean,
  isBasketProcessed: boolean,
  canSetDropShip: boolean | number,
  allowMDOUpload: boolean,
  showClearDiscountsButton: boolean,
) {
  const conditions = [
    { type: IBasketActionTypes.DROP_SHIP, isAllowed: canSetDropShip },
    {
      type: IBasketActionTypes.SEND_PDF_CONFIRMATION,
      isAllowed: isBasketProcessed && isAllowedToResendOrderConfirmation,
    },
    { type: IBasketActionTypes.UPLOAD_MDO_BASKET, isAllowed: allowMDOUpload },
    {
      type: IBasketActionTypes.CLEAR_MANUAL_DISCOUNTS,
      isAllowed: showClearDiscountsButton,
    },
  ];

  return conditions.reduce(
    (collection, { type, isAllowed }) =>
      collection.filter(({ actionType }) => actionType !== type || isAllowed),
    actions,
  );
}
